import { createUseStyles } from 'react-jss'
import { darkGrey } from '../../../../../../styles/const/colors'
import { phonesDown } from '../../../../../../styles/const/breakpoints'

const useStyles = createUseStyles({
  refreshButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 37,
    padding: '7px 10px'
  },
  refreshButtonIcon: {
    marginLeft: [0, '!important'],
    margin: '0 10px',
    color: darkGrey,
    maxWidth: 21
  },
  [`@media screen and (${phonesDown})`]: {
    refreshButton: {
      height: 32
    },
    refreshButtonIcon: {
      maxWidth: 19
    }
  }
})

export default useStyles
